module.exports = __webpack_public_path__ + "static/media/calendar.50231ccc.svg";